import { Menu as MenuIcon } from "@mui/icons-material"
import { AppBar, Box, IconButton, Popover, Toolbar, Typography, useMediaQuery, useTheme } from "@mui/material"
import { AppProfile } from "components"
import AppMenu from "containers/AppMenu"
import { useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import { privateRoute } from "routes"

const AppHeader = () => {
  const location = useLocation()
  const theme = useTheme()
  const showHorizontalNavigation = useMediaQuery(theme.breakpoints.up("lg"))

  const [navigationAnchor, setNavigationAnchor] = useState<HTMLElement | null>(null)

  useEffect(() => {
    setNavigationAnchor(null)
  }, [location.pathname, showHorizontalNavigation])

  return (
    <AppBar color="inherit" elevation={1} position="sticky">
      <Toolbar sx={{ gap: 2 }}>
        {!showHorizontalNavigation && (
          <IconButton
            aria-controls={navigationAnchor ? "app-navigation-menu" : undefined}
            aria-expanded={Boolean(navigationAnchor)}
            aria-haspopup="true"
            aria-label="Mở menu điều hướng"
            onClick={(event) => setNavigationAnchor(event.currentTarget)}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Link to={privateRoute.home.path}>
          <Typography color="primary" variant="h5" whiteSpace="nowrap">
            Airdata Portal
          </Typography>
        </Link>

        {showHorizontalNavigation && <AppMenu orientation="horizontal" />}

        <Box flex={1}>
          <AppProfile />
        </Box>

        <Popover
          anchorEl={navigationAnchor}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
          id="app-navigation-menu"
          onClose={() => setNavigationAnchor(null)}
          open={Boolean(navigationAnchor)}
          slotProps={{ paper: { sx: { minWidth: 240, p: 1 } } }}
          transformOrigin={{ horizontal: "left", vertical: "top" }}
        >
          <AppMenu />
        </Popover>
      </Toolbar>
    </AppBar>
  )
}

export default AppHeader
